var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCsvExportIllo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 67,
  height: 84,
  viewBox: "0 0 67 84",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#A0AEB9",
  fillRule: "nonzero",
  d: "M13 29v50h40V29zm0-4h40a4 4 0 0 1 4 4v50a4 4 0 0 1-4 4H13a4 4 0 0 1-4-4V29a4 4 0 0 1 4-4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 4,
  r: 2,
  fill: "#A4FBE7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 35,
  r: 2,
  fill: "#A4FBE7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 9,
  r: 2,
  fill: "#A4FBE7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#16E3B3",
  fillRule: "nonzero",
  d: "m14.897 8.881 3.652-.91-2.736-3.197zm1.135-6.927 5.089 5.945a1 1 0 0 1-.518 1.62l-6.792 1.694a1 1 0 0 1-1.218-1.188l1.703-7.639a1 1 0 0 1 1.736-.432"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 18,
  r: 2,
  fill: "#A4FBE7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#16E3B3",
  fillRule: "nonzero",
  d: "m3.707 16.293 1.414 1.413 1.415-1.413a1 1 0 1 1 1.414 1.414l-1.415 1.414 1.415 1.415a1 1 0 0 1-1.414 1.414L5.12 20.535 3.707 21.95a1 1 0 1 1-1.414-1.414l1.413-1.415-1.413-1.414a1 1 0 0 1 1.414-1.414M43.896 1.937l.75 1.853 1.854-.748a1 1 0 0 1 .749 1.854l-1.855.749.75 1.855a1 1 0 1 1-1.855.749l-.749-1.855-1.854.75a1 1 0 0 1-.75-1.855l1.854-.75-.748-1.853a1 1 0 1 1 1.854-.75M32 20a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M63 26a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 18,
  r: 2,
  fill: "#A4FBE7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 31,
  r: 2,
  fill: "#A4FBE7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0DAE1",
  d: "M26 33v6h-9v-6zm23 0v6H29v-6zM26 42v6h-9v-6zm23 0v6H29v-6zM26 51v6h-9v-6zm23 0v6H29v-6zM26 60v6h-9v-6zm23 0v6H29v-6zM26 69v6h-9v-6zm23 0v6H29v-6z"
}))));
export default SvgCsvExportIllo;